import UserUnsubscribe from '../../components/authentication/user-unsubscribe/UserUnsubscribe';
import { AppActions } from '../../redux/AppActions';
import { FC, useEffect } from 'react';
import { useAppDispatch } from '../../redux/store';

const UnsubscribePage: FC = () => {
	const dispatch = useAppDispatch();
	const setShowNavbar = (show: boolean) => dispatch(AppActions.showNavbar(show));
	useEffect(() => {
		setShowNavbar(false);
		return () => {
			setShowNavbar(true);
		};
	}, []);
	return <UserUnsubscribe />;
};

export default UnsubscribePage;
